/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class FinancialApi {
    static getInstance() {
        if (!this.instance) this.instance = new FinancialApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 获取订单列表
    async getOrderList (param, page_num, page_size){
        let url = `/api/order/head/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 更新订单付款时间
    async updatePaymentDate (param, id){
        let url = `/api/order/head/${id}/payment`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 更新订单付款状态
    async updatePaymentStatus (param, id){
        let url = `/api/order/head/update/status/${id}/finance`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 编辑备注 
    async saveComment (param){
        let url = `/api/order/head/${param.id}/finance/instruction`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 现金流、应付列表 
    async cashAndAccountList (param,num,size){
        let url = `/api/finance/list?page_num=${num}&page_size=${size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 保存现金流、应付
    async saveCashAndAccount (param){
        let url = `/api/finance/save`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取价目表
    async getPriceList (param,num,size){
        let url = `/api/system/source/price/list?page_num=${num}&page_size=${size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 同步ERP价目表
    async syncErpPriceList (param){
        let url = `/api/system/source/price/synchronize`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 根据sku获取整车价格
    async getBikePriceBySku (param){
        let url = `/api/system/source/price/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 数据导出
    async exportPriceData (param){
        let url = `/api/system/source/price/export/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 逾期清单
    async getOverdueList (param){
        let url = `/api/invoice/overdue/list`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // SEPA收款
    async getSEPACollectionList (param){
        let url = `/api/invoice/sepa/list`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 保存备注-逾期清单
    async saveRemarkOverdueList (param, id){
        let url = `/api/invoice/${id}/instruction`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 财务确认执行状态-SEPA收款
    async confirmStatusSEPACollection (param, id){
        let url = `/api/invoice/${id}/finance/confirm`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 发货签收
    async getSignatureList (param, page_num, page_size){
        let url = `/api/logistic/sign/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 下载发货签收模板
    async downloadSignTemplate (){
        let url = `/api/logistic/sign/export/templates`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 下载退货签收模板
    async downloadReturnSignTemplate (){
        let url = `/api/logistic/sign/export/return/templates`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 导入发货签收数据
    // async importSignData (param){
    //     let url = `/api/logistic/sign/import`
    //     let result = await this.getData(url,param,'POST','multipart/form-data')
    //     return result
    // }

    // 导入退货签收数据
    // async importReturnSignData (param){
    //     let url = `/api/logistic/sign/import/return`
    //     let result = await this.getData(url,param,'POST','multipart/form-data')
    //     return result
    // }

}

export {
    FinancialApi
}